import React, { useState } from 'react'
import DefaultLink from '../../components/DefaultLink'
import BoardModal from './BoardModal';

export default function ManagementTeam({ teamData }) {
  const [selectdMember, setSelectedMember] = useState(null);

  return (
    <>
      <section className='team-board-manage'>
        <div className='container'>
          <div className='row  justify-content-center'>
            <div className='col-lg-12'>
              <h3 className='heading center-heading'>Management Team</h3>
            </div>
            {teamData.map((item, index) =>(
              <div className='col-lg-4 col-md-6' key={index}>
                <div className='team-director-card'>
                  <div className='director-card-content'>
                    <img src={item?.img} alt='User' />
                    <div>
                      <span>{item?.name}</span>
                      <p>{item?.role}</p>
                    </div>
                  </div>
                  <DefaultLink to={""} onClick={() => setSelectedMember(item)} text={"Read More"} />
                </div>
              </div>
            ))}
            <BoardModal data={selectdMember} onClose={() => setSelectedMember(null)} />
          </div>
        </div>
      </section>
    </>
  )
}
